import toast from "react-hot-toast";

export default function LinksTable({ links, loading }) {
  return (
    <section className="overflow-hidden rounded-[32px] border border-white/10 bg-[rgba(11,18,31,0.92)] shadow-[0_30px_80px_rgba(0,0,0,0.28)]">
      <div className="overflow-x-auto">
        <table className="min-w-full text-left text-sm">
          <thead className="border-b border-white/10 bg-white/[0.03] text-[11px] uppercase tracking-[0.24em] text-[var(--aff-muted)]">
            <tr>
              <th className="px-5 py-4">Link</th>
              <th className="px-5 py-4">Comment</th>
              <th className="px-5 py-4">Type</th>
              <th className="px-5 py-4">Program</th>
              <th className="px-5 py-4">Created</th>
              <th className="px-5 py-4">Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <PlaceholderRow label="Loading links..." />
            ) : links.length ? (
              links.map((link) => (
                <tr key={link.id} className="border-b border-white/6 text-slate-200">
                  <td className="px-5 py-4">
                    <div className="font-semibold text-white">#{link.id.slice(-8)}</div>
                    <div className="max-w-[320px] break-all text-xs text-slate-400">
                      {link.referralLink}
                    </div>
                  </td>
                  <td className="px-5 py-4">{link.comment || "No comment"}</td>
                  <td className="px-5 py-4">{link.linkType}</td>
                  <td className="px-5 py-4">
                    <span className="rounded-full border border-white/10 bg-white/[0.05] px-3 py-1 text-xs font-semibold text-white">
                      {link.program}
                    </span>
                  </td>
                  <td className="px-5 py-4 text-slate-400">
                    {link.createdAt?.toDate
                      ? link.createdAt.toDate().toLocaleDateString()
                      : "Just now"}
                  </td>
                  <td className="px-5 py-4">
                    <div className="flex flex-wrap gap-2">
                      <button
                        type="button"
                        onClick={() => {
                          navigator.clipboard.writeText(link.referralLink || "");
                          toast.success("Referral link copied.");
                        }}
                        className="rounded-xl border border-white/10 bg-white/[0.05] px-3 py-2 text-xs font-semibold text-white"
                      >
                        Copy
                      </button>
                      <a
                        href={link.referralLink}
                        target="_blank"
                        rel="noreferrer"
                        className="rounded-xl border border-emerald-400/20 bg-emerald-400/10 px-3 py-2 text-xs font-semibold text-emerald-100"
                      >
                        Open
                      </a>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <PlaceholderRow label="No links created yet." />
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}

function PlaceholderRow({ label }) {
  return (
    <tr>
      <td colSpan={6} className="px-5 py-12 text-center text-sm text-slate-400">
        {label}
      </td>
    </tr>
  );
}
